import React, { Component } from "react";
// import moment from "moment";
import moment from "moment-timezone";

import AdmissionApi, { acz } from "../../../Services/AdmissionApi";
import Paging from "../../Paging";
import "./style.css";
import { CSVLink } from "react-csv";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import Dialog from "material-ui/Dialog"; 

class Students extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      csvData: [],
      selectedName: "",
      selectedSchool: "",
      selectedClass: "",
      selectedPassingYear: "",
      page: 1,
      pageSize: 20,
      totalPages: 1,

      timeFilter: "all",
      showTimeDialog: false,
      timeDialogUser: null,
      timeDialogData: [],
      timeDialogAvg: "00:00:00",
      customStartDate: "",
      customEndDate: "",
    };

    this.admissionsService = new AdmissionApi();
  }

  componentDidMount() {
    this.getData();
    this.getData(1, true);
  }

  updateState = (response) => {
    this.setState({
      users: response.data._embedded.students,
      page: response.data.page,
      totalPages: response.data.pageCount,
    });
  };

  updateExportData = (res) => {
    const records = res.data._embedded.students;

    const data = records.map((item) => ({
      "First Name": item.first_name,
      "Last Name": item.last_name,
      "Date of Birth": moment(item.date_of_birth).format("DD/MM/YYYY"),
      Gender: item.gender,
      Email: item.email,
      "Phone Number": item.phone_number,
      "Father Name": item.father_name,
      "School Name": item.school_name,
      "School Code": item.school_code,
      "Average Time Spent (Minutes)": (item.avgTimeSpent / 60).toFixed(3),
      Class: item.class,
      "Year of passing class 12th": item.batch,
      Subjects: item.subjects.map((i) => i.label).join(", "),
      Approval: (item.approval_status || "pending").toString(),
    }));
    this.setState({ csvData: data });

  };

  getData = (page = 1, isExport = false) => {
    let filters = "";
    const {
      selectedName,
      selectedSchool,
      selectedClass,
      selectedPassingYear,
      pageSize,
    } = this.state;
  
    const { clientId, appId } = acz;
    const config = {
      client_id: clientId,
      app_key: appId,
    };
  
    if (selectedName) filters += `&name=${encodeURIComponent(selectedName)}`;
    if (selectedSchool) filters += `&school_name=${encodeURIComponent(selectedSchool)}`;
    if (selectedClass) filters += `&class=${encodeURIComponent(selectedClass)}`;
    if (selectedPassingYear) filters += `&batch=${encodeURIComponent(selectedPassingYear)}`;
  
    
    const dr = this.getDateRangeFromState(); 
    const rangeObj = this.buildRangeFilter(dr);
  
    if (rangeObj && Object.keys(rangeObj).length) {
      if (rangeObj.dateRangeType) {
        filters += `&dateRangeType=${encodeURIComponent(rangeObj.dateRangeType)}`;
        if (rangeObj.dateRangeType === "dateRange") {
          filters += `&startDate=${encodeURIComponent(rangeObj.startDate)}`;
          filters += `&endDate=${encodeURIComponent(rangeObj.endDate)}`;
        } else if (rangeObj.dateRangeType === "lastxdays" && rangeObj.day != null) {
          filters += `&day=${encodeURIComponent(String(rangeObj.day))}`;
        }
      }
    }
  
    const pageSizeParam = !isExport ? pageSize : "999999999999";
  
    this.admissionsService.GetStudentsData(
      !isExport ? this.updateState : this.updateExportData,
      `v1/students?page=${page}&pageSize=${pageSizeParam}&column=created_at&order=desc${filters}`,
      config
    );
  };
  
  handleFilterInputChange = (event) => {
    const { id, value } = event.target;
    this.setState({
      [id]: value,
    });
  };

  filterList = (e) => {
    e.preventDefault();
    this.getData();
    this.getData(1, true);
  };

  clearFilter = () => {
    this.setState(
      {
        selectedName: "",
        selectedSchool: "",
        selectedClass: "",
        selectedPassingYear: "",
      },
      () => {
        this.getData();
        this.getData(1, true);
      }
    );
  };

  handlePageChange = (page) => {
    this.getData(page);
  };

  fetchDataToExport = (event) => {
    if (!this.state.csvData.length) event.preventDefault();
  };


  formatMsToHHMMSS(ms) {
    // let ms = sec*1000
    if (!ms || ms < 0) return "00:00:00";
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

buildRangeFilter = (dr) => {
  if (!dr) return {};
  if (dr.preset === "custom") {
    return {
      dateRangeType: "dateRange",
      startDate: dr.dateFrom, 
      endDate: dr.dateTo,     
    };
  }
  return {
    dateRangeType: "lastxdays",
    day: Number(dr.preset), 
  };
};

getDateRangeFromState = () => {
  const { timeFilter, customStartDate, customEndDate } = this.state;

  if (!timeFilter || timeFilter === "all") return null;

  if (timeFilter === "today") {
    return { preset: "1" }; 
  }

  if (timeFilter === "custom") {
   
    if (!customStartDate || !customEndDate) return null;
    return {
      preset: "custom",
      dateFrom: customStartDate,
      dateTo: customEndDate,
    };
  }

  if (["7", "15", "30", "90"].includes(timeFilter)) {
    return { preset: timeFilter };
  }

  return null;
};


  getStaticTimesForUser(user) {
    const offset = user && user.id ? (parseInt(user.id, 10) % 10) : 0;
    const baseDates = [
      moment().subtract(1 + offset, "days"),
      moment().subtract(2 + offset, "days"),
      moment().subtract(3 + offset, "days"),
      moment().subtract(4 + offset, "days"),
    ];

    return baseDates.map((d, i) => {
      const login = d.clone().hour(8).minute(30 + (i * 5) + offset).second(0);
      const logout = login.clone().add(90 + (i * 10) + offset * 2, "minutes");
      const timeSpentMs = logout.diff(login);
      return {
        date: d.format("YYYY-MM-DD"),
        loginTime: login.toISOString(),
        logoutTime: logout.toISOString(),
        timeSpentMs,
      };
    });
  }


  filterTimesByRange = (rows, timeFilter) => {
    if (!rows || !rows.length) return [];
    if (!timeFilter || timeFilter === "all") return rows;

    const today = moment().startOf("day");
    let start = null;
    let end = today.clone().endOf("day");

    switch (timeFilter) {
      case "today":
        start = today.clone().startOf("day");
        break;
      case "7":
        start = today.clone().subtract(6, "days");
        break;
      case "15":
        start = today.clone().subtract(14, "days");
        break;
      case "30":
        start = today.clone().subtract(29, "days");
        break;
      case "90":
        start = today.clone().subtract(89, "days");
        break;
      case "custom": {
        const { customStartDate, customEndDate } = this.state;
        if (!customStartDate || !customEndDate) return [];
        // parse date inputs (YYYY-MM-DD) and set to day boundaries
        const s = moment(customStartDate, "YYYY-MM-DD").startOf("day");
        const e = moment(customEndDate, "YYYY-MM-DD").endOf("day");
        if (!s.isValid() || !e.isValid() || e.isBefore(s)) return [];
        start = s;
        end = e;
        break;
      }
      default:
        start = null;
    }

    if (!start) return rows;

    return rows.filter((r) => {
      const d = moment(r.date, "YYYY-MM-DD");
      return d.isSameOrAfter(start, "day") && d.isSameOrBefore(end, "day");
    });
  };

  handleTimeFilterChange = (e) => {
    const value = e.target.value;
    this.setState({ timeFilter: value }, () => {
      this.getData(1);
      this.getData(1, true);
    });
  };
  

  handleCustomDateChange = (e) => {
    const { id, value } = e.target; 
    this.setState({ [id]: value });
  };

applyCustomRange = () => {
  const { customStartDate, customEndDate } = this.state;
  if (!customStartDate || !customEndDate) {
    toast.error("Please select both start and end dates for custom range.");
    return;
  }
  const s = moment(customStartDate, "YYYY-MM-DD");
  const e = moment(customEndDate, "YYYY-MM-DD");
  if (!s.isValid() || !e.isValid() || e.isBefore(s)) {
    toast.error("Invalid date range. Ensure the end date is the same or after start date.");
    return;
  }


  this.setState({ timeFilter: "custom" }, () => {

    this.getData(1);
    this.getData(1, true);
  });
};




  // open dialog and compute average
  openTimeDialog = (user) => {
    if (!user || !user.id) {
      console.error("No user id found for time dialog");
      return;
    }


  
    const userId = Number(user.id);
    // console.log("Fetching activity for user:", userId);
  
    const url = `https://api.notifyi.in/v1/student-activity/get-activity/${userId}`;
  
   
  
    const clientId = localStorage.getItem("clientId") || "12";
    const appId = localStorage.getItem("appId") || "12";
  
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "clientid": clientId,
        "appid": appId,
      },
      // body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {

        const avgSec = user.avgTimeSpent || 0;     
        const avgMs = avgSec*1000;               
        const avgFormatted = this.formatMsToHHMMSS(avgMs);
        this.setState({
          showTimeDialog: true,
          timeDialogUser: user,
          timeDialogData: data.records||[], 
          timeDialogAvg: avgFormatted,
        });
      })
      .catch((err) => {
        console.error("Error fetching activity:", err);
      });
  };
  
  closeTimeDialog = () => {
    this.setState({
      showTimeDialog: false,
      timeDialogUser: null,
      timeDialogData: [],
      timeDialogAvg: "00:00:00",
    });
  };

  // ---------- EXISTING: Approval helpers & delete (unchanged) ----------

  getStatusBadge = (statusRaw) => {
    const status = (statusRaw || "pending").toLowerCase();
    const base = {
      display: "inline-block",
      padding: "2px 8px",
      borderRadius: "12px",
      fontSize: 12,
      lineHeight: "16px",
      border: "1px solid transparent",
    };

    if (status === "approved")
      return (
        <span
          style={{
            ...base,
            color: "#1f7a1f",
            background: "#eaf8ea",
            borderColor: "#bde5bd",
          }}
        >
          Approved
        </span>
      );
    if (status === "rejected")
      return (
        <span
          style={{
            ...base,
            color: "#a11",
            background: "#fdeaea",
            borderColor: "#f5c2c2",
          }}
        >
          Rejected
        </span>
      );
    return (
      <span
        style={{
          ...base,
          color: "#955f00",
          background: "#fff6e5",
          borderColor: "#ffd89b",
        }}
      >
        Pending
      </span>
    );
  };

  updateApprovalStatus = (item, nextStatus) => {
    const nice = nextStatus === "approved" ? "approve" : "reject";

    this.admissionsService.updateStudent(
      (res) => {
        if (res.status === 200) {
          toast.success(`Student ${nextStatus} successfully.`);
          this.getData(this.state.page);
        }
      },
      "v1/students",
      item.id,
      {
        approval_status: nextStatus,
        first_name: item.first_name,
        last_name: item.last_name,
        school_code: item.school_code,
      }
    );
  };

  renderStatusCell = (item) => {
    const status =
      (item.approval_status || item.status || "pending").toLowerCase();

    return (
      <div className="flex items-center" style={{ gap: 8 }}>
        {this.getStatusBadge(status)}
      </div>
    );
  };

  renderApprovalCell = (item) => {
    const status = (item.approval_status || item.status || "pending").toLowerCase();
    const isPending = status === "pending";

    return (
      <div className="flex items-center" style={{ gap: 8 }}>
        <div className="d-flex mt-2" style={{ gap: 6, marginLeft: 8 }}>
          {isPending ? (
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn--primary mr-2"
                onClick={() => this.updateApprovalStatus(item, "approved")}
              >
                Approve
              </button>
              <button
                type="button"
                className="btn btn--primary"
                onClick={() => this.updateApprovalStatus(item, "rejected")}
              >
                Reject
              </button>
            </div>
          ) : (
            <div>
              {status !== "approved" && (
                <button
                  type="button"
                  className="btn btn--primary"
                  onClick={() => this.updateApprovalStatus(item, "approved")}
                >
                  Approve
                </button>
              )}
              {status !== "rejected" && (
                <button
                  type="button"
                  className="btn btn--primary"
                  onClick={() => this.updateApprovalStatus(item, "rejected")}
                >
                  Reject
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  deleteItem = (item) => {
    confirmAlert({
      title: "Confirm ?",
      message: "Are You Sure you want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.admissionsService.deleteStudent(
              (res) => {
                if (res.status === 200) {
                  this.admissionsService.deleteStudent(
                    (res) => {
                      if (res.status === 200) {
                        toast.success("Student record deleted successfully.");
                        this.getData();
                      }
                    },
                    "v1/users",
                    item.user_id
                  );
                }
              },
              "v1/students",
              item.id
            );
          },
        },
        {
          label: "No",
          onClick: () => {
            console.log("Cancel");
          },
        },
      ],
    });
  };

  // ------------------------------------------

  render() {
    const {
      users,
      page,
      totalPages,
      selectedName,
      selectedSchool,
      selectedClass,
      selectedPassingYear,
      csvData,
      timeFilter,
      showTimeDialog,
      timeDialogUser,
      timeDialogData,
      timeDialogAvg,
      customStartDate,
      customEndDate,
    } = this.state;
    const { showDetails, updateRoutePage } = this.props;

    return (
      <section className="dash-alerts">
        <form>
          <div className="alert-filter">
            <input
              id="selectedName"
              type="text"
              className="form-control alert-filter__input mr-2"
              placeholder="Name"
              value={selectedName}
              onChange={this.handleFilterInputChange}
            />
            <input
              id="selectedSchool"
              type="text"
              className="form-control alert-filter__input mr-2"
              placeholder="School"
              value={selectedSchool}
              onChange={this.handleFilterInputChange}
            />
            <input
              id="selectedClass"
              type="text"
              className="form-control alert-filter__input mr-2"
              placeholder="Class"
              value={selectedClass}
              onChange={this.handleFilterInputChange}
            />
            <input
              id="selectedPassingYear"
              type="text"
              className="form-control alert-filter__input mr-2"
              placeholder="Year of passing class 12th"
              value={selectedPassingYear}
              onChange={this.handleFilterInputChange}
            />
            <button
              type="submit"
              onClick={this.filterList}
              className="btn btn--primary"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={this.clearFilter}
              className="btn btn--default ml-2"
            >
              Clear
            </button>
            <CSVLink
              className="btn btn--new ml-2"
              data={csvData}
              filename={"student-records.csv"}
              onClick={this.fetchDataToExport}
            >
              Export
            </CSVLink>
          </div>
        </form>

        {/* Time filter dropdown (with label) */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginTop: "10px",
            marginBottom: "6px",
            alignItems: "center",
            gap: 8,
          }}
        >
          <label htmlFor="timeFilter" style={{ fontSize: 13, fontWeight: 600 }}>
            Session range:
          </label>

          <select
            id="timeFilter"
            value={timeFilter}
            onChange={this.handleTimeFilterChange}
            className="form-control alert-filter__input"
            style={{ width: 180, padding: "6px 10px" }}
          >
            <option value="all">All (no filter)</option>
            <option value="today">Today</option>
            <option value="7">Last 7 days</option>
            <option value="15">Last 15 days</option>
            <option value="30">Last 30 days</option>
            <option value="90">Last 90 days</option>
            <option value="custom">Custom range</option>
          </select>

          {/* custom range inputs shown only when 'custom' selected */}
          {timeFilter === "custom" && (
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <input
                id="customStartDate"
                type="date"
                value={customStartDate}
                onChange={this.handleCustomDateChange}
                className="form-control"
                style={{ padding: "6px 8px" }}
              />
              <span style={{ fontSize: 14, marginLeft: 4, marginRight: 4 }}>—</span>
              <input
                id="customEndDate"
                type="date"
                value={customEndDate}
                onChange={this.handleCustomDateChange}
                className="form-control"
                style={{ padding: "6px 8px" }}
              />
              <button type="button" className="btn btn--primary" onClick={this.applyCustomRange}>
                Apply
              </button>
            </div>
          )}
        </div>

        <table className="table table-responsive alert-table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">School</th>
              <th scope="col">School Code</th>
              <th scope="col">Class</th>
              <th scope="col">Year of passing class 12<sup>th</sup></th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Gender</th>
              <th scope="col">Date of birth</th>

              {/* NEW COLUMN: Time spent (avg) */}
              <th scope="col">Time spent (avg)</th>

              {/* EXISTING */}
              <th scope="col">Status</th>
              <th scope="col">Approval</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {users.map((item) => {
              // compute avg using static generator
              const allTimes = this.getStaticTimesForUser(item);
              const filteredTimes = this.filterTimesByRange(allTimes, timeFilter);
              const totalMs = filteredTimes.reduce((acc, r) => acc + (r.timeSpentMs || 0), 0);
              const avgMs = item.avgTimeSpent*1000
              const avgFormatted = this.formatMsToHHMMSS(avgMs);

              return (
                <tr key={item.id}>
                  <td className="text-capitalize">
                    {item.first_name} {item.last_name}
                  </td>
                  <td>{item.school_name}</td>
                  <td>{item.school_code}</td>
                  <td>{item.class}</td>
                  <td>{item.batch}</td>
                  <td>{item.email}</td>
                  <td>{item.phone_number}</td>
                  <td className="text-capitalize">{item.gender}</td>
                  <td>{moment(item.date_of_birth).format("DD/MM/YYYY")}</td>

                  {/* Time spent column */}
                  <td className="d-flex align-items-center">
                  <span className="badge">{avgFormatted}</span>

                  <button
                    type="button"
                    className="btn btn-link alert-table__link ms-2"
                    title="View time details"
                    onClick={() => this.openTimeDialog(item)}
                  >
                    <i className="icon-eye" />
                  </button>
                </td>


                  <td>{this.renderStatusCell(item)} </td>

                  <td>{this.renderApprovalCell(item)}</td>

                  <td className="d-flex">
                    <button
                      className="btn btn-link alert-table__link"
                      onClick={() => this.deleteItem(item)}
                    >
                      <i className="icon-trash" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <Paging page={page} totalPages={totalPages} onChange={this.handlePageChange} />

        {/* Time details dialog (new) */}
        <Dialog
  className="dash-time-modal"
  title={
    timeDialogUser
      ? `Time details — ${timeDialogUser.first_name || ""} ${timeDialogUser.last_name || ""}`
      : "Time details"
  }
  modal={false}
  open={showTimeDialog}
  onRequestClose={this.closeTimeDialog}
>
  <div style={{ padding: 16, minWidth: 520, position: "relative" }}>
    <div style={{ marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h3 style={{ margin: 0 }}>Session history</h3>
      <div>
        <strong>Avg: </strong><span>{timeDialogAvg}</span>
      </div>
    </div>

    <div
      style={{
        maxHeight: "60vh",
        overflowY: "auto",
        overflowX: "auto",
        borderTop: "1px solid #eee",
        borderBottom: "1px solid #eee",
        paddingBottom: 8,
      }}
    >
      <table className="table" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>Date</th>
            <th style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>Login Time</th>
            <th style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>Logout Time</th>
            <th style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>Time Spent</th>
          </tr>
        </thead>
        <tbody>
          {timeDialogData.length ? timeDialogData.map((row, idx) => (
            <tr key={idx}>
       <td>
  {row.date
    ? moment.utc(row.date).tz("Asia/Kolkata").format("DD/MM/YYYY")
    : "-"
  }
</td>
            <td>
  {row.loginTime
    ? moment.utc(row.loginTime).tz("Asia/Kolkata").format("HH:mm:ss")
    : "-"
  }
</td>
<td>
  {row.logoutTime
    ? moment.utc(row.logoutTime).tz("Asia/Kolkata").format("HH:mm:ss")
    : "-"
  }
</td>
              <td>{this.formatMsToHHMMSS(row.timeSpent*1000)}</td>
            </tr>
          )) : (
            <tr>
              <td colSpan={4} style={{ textAlign: "center" }}>No sessions in selected range</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    <div style={{ textAlign: "right", marginTop: 12 }}>
      <button className="btn btn--default" onClick={this.closeTimeDialog}>Close</button>
    </div>
  </div>
</Dialog>

      </section>
    );
  }
}

export default Students;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/Students/index.js
 **/